import { ArrowRight, Loader2 } from "lucide-react"
import { Link } from "react-router-dom"
import type { RichToolCall } from "@/lib/ag-ui-types"

function parseNavTarget(toolCall: RichToolCall): { label: string; url: string } {
  try {
    const args = JSON.parse(toolCall.args)
    return { label: args.label || args.page || "Strona", url: args.url || args.path || "/" }
  } catch {
    return { label: "Nawigacja", url: "/" }
  }
}

export function NavigationCard({ toolCall }: { toolCall: RichToolCall }) {
  const isDone = toolCall.status === "done"
  const { label, url } = parseNavTarget(toolCall)

  if (!isDone) {
    return (
      <div
        className="my-2 flex items-center gap-2 rounded-lg px-3 py-2"
        style={{ border: "1px solid var(--border)", background: "var(--bg-surface)" }}
      >
        <Loader2 size={14} className="animate-spin" style={{ color: "var(--primary)" }} />
        <span className="text-xs" style={{ color: "var(--text-primary)" }}>Nawigacja...</span>
      </div>
    )
  }

  return (
    <Link
      to={url}
      className="my-2 flex items-center gap-2.5 rounded-lg px-3 py-2.5 transition-colors"
      style={{ border: "1px solid var(--border)", background: "var(--bg-surface)" }}
      onMouseEnter={(e) => { e.currentTarget.style.background = "var(--bg-surface-raised)" }}
      onMouseLeave={(e) => { e.currentTarget.style.background = "var(--bg-surface)" }}
    >
      <ArrowRight size={14} style={{ color: "var(--primary)" }} />
      <span className="flex-1 text-xs font-medium" style={{ color: "var(--text-primary)" }}>Przejdź do: {label}</span>
      <span className="text-[10px]" style={{ color: "var(--primary)" }}>Otwórz →</span>
    </Link>
  )
}
